import type { Panel } from "./schemas"

/**
 * Panel ↔ route eşlemesi. Hems route'ları prefix'siz (mevcut yapı korunur);
 * CNI route'ları `/cni/*` ağacında. `panelOfRoute()` bir path'in hangi panele
 * ait olduğunu döner — `null` => panel-bağımsız (login, /select-panel, /account).
 */

export function dashboardPath(panel: Panel): "/dashboard" | "/cni/dashboard" {
  return panel === "hems" ? "/dashboard" : "/cni/dashboard"
}

const PANEL_AGNOSTIC_PREFIXES = ["/select-panel", "/account", "/login"] as const

export function panelOfRoute(pathname: string): Panel | null {
  if (PANEL_AGNOSTIC_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`))) {
    return null
  }
  if (pathname === "/cni" || pathname.startsWith("/cni/")) {
    return "cni"
  }
  // Mevcut tüm Hems route'ları (dashboard, devices, sites, partners, ...) Hems sayılır.
  return "hems"
}
